import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { environment } from '../../environments/environment';

//Genera PDF
// import * as pdfMake from 'pdfmake/build/pdfmake.js';
// import * as pdfFonts from 'pdfmake/build/vfs_fonts.js';
// pdfMake.vfs = pdfFonts.pdfMake.vfs;
var pdfMake = require('pdfmake/build/pdfmake.js');
var pdfFonts = require('pdfmake/build/vfs_fonts.js');
pdfMake.vfs = pdfFonts.pdfMake.vfs;

//Genera XLS
import * as fs from 'file-saver';
import * as Excel from "exceljs/dist/exceljs.min.js";

import * as moment from 'moment';
import 'moment/locale/es/';
moment.locale('es');

import 'moment-duration-format';
//import { Router, ActivationStart } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HttpClient } from '@angular/common/http';
import { randomBytes } from 'crypto';


@Injectable({
    providedIn: 'root'
})
export class Gtp {

    private closeWindow = new Subject<any>();
    private mainOutlet = new Subject<any>();
    private mainSidebar = new Subject<any>();
    private rightSidebar = new Subject<any>();
    public rightSidebarOpened = true;
    private adminSidebar = new Subject<any>();

    //Idioma DateTimePicker
	  fechalang: any = {
      firstDayOfWeek: 0,
      dayNames: ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
      dayNamesShort: ["Dom", "Lun", "Mar", "Mie", "Juev", "Vie", "Sab"],
      dayNamesMin: ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sa"],
      monthNames: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
      monthNamesShort: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
      today: 'Ahora',
      clear: 'Limpiar'
    };

    public btnSaveAdminLabel = "GRABAR";

    //Tamaño Mínimo de Pop Up de Dialogos de confirmación
    public confirmMinWidh = '400px';
    public graficMinWidh  = '1000px';
    //Colores para tablas, se considera para exportar pdf
    tableColors:any = {
        header      : '#d1d5d8',
        footer      : '#d1d5d8',
        td          : '#ffffff',
        tdinterval  : '#e9ecef'
    }

    constructor(
      private titleService?: Title,
      private snackBar?: MatSnackBar,
      private http?: HttpClient
    ){
    }

    /**
     * Cambia el title de la página
     * @param newTitle string
     */
    setTitle(newTitle: string) {
      this.titleService.setTitle(newTitle + ' : Rastreo GTP');
    }

    /**
     *
     * @param name nombre de la variable a insertar en storage
     * @param obj objeto a ingresar en storage
     * @example
     * setItemLocalStorage('usuario', { userid: 1 })
     */
    setItemLocalStorage(name: string, obj: Object) {
        localStorage.setItem(name, JSON.stringify(obj));
    }

    /**
     * Devuelve un valor del Local Storage
     * @param name nombre de la variable en storage
     */
    removeItemLocalStorage(name: string) {
        localStorage.removeItem(name);
    }

    /**
     * Devuelve un valor del Local Storage
     * @param name nombre de la variable en storage
     * @returns string
     */
    getItemLocalStorage(name: string): string {
        return localStorage.getItem(name);
    }

    /**
     * Devuelve los datos del usuario activo
     * @return {string} "{"username":" ","token": "","cod_cliente":0 ,"perfil":" "}"
     */
    getUserData(): string {
        return this.getItemLocalStorage('currentUser');
    }

    getUserDataParse(): string {
      return JSON.parse(this.getItemLocalStorage('currentUser'))
    }

    /**
     * Devuelve los datos del móvil activo
     * @returns {json} { cod_equipo_rastreo":2013,"fecha_hora":"2020-03-24T13:03:44.672Z","des_equipo_ratreo":"600 LUA Transporte BPG925" }
     */
    getSingleMovilData(): string {
        return JSON.parse(this.getItemLocalStorage('movilActivo'));
    }

    checkVentanas(){
        return this.closeWindow.asObservable();
    }

    cerrarVentanas(obj){
        this.setMainOutlet(false);
    }

    /**
     * Devuelve observable para sidebar izquierdo
     */
    getMainSidebar(){
        return this.mainSidebar.asObservable();
    }

    /**
     * Setea componente para el sidebar izquierdo
     */
    setMainSidebar(val=true){
      this.mainSidebar.next(val);
    }
    /**
     * Devuelve observable para sidebar derecho
     */
    getRightSidebar(){
        return this.rightSidebar.asObservable();
    }

    /**
     * Setea componente para el sidebar derecho
     */
    setRightSidebar(obj){
        this.rightSidebar.next(obj);
    }

    /**
     * Devuelve observable para sidebar derecho
     */
    getAdminSidebar(){
      return this.adminSidebar.asObservable();
    }
    /**
     * Setea componente para el sidebar derecho
     */
    setAdminSidebar(obj){
      this.adminSidebar.next(obj);
    }

    /**
     * Aumenta o disminuye el tamaño del ancho en el informe.
     */
    containerSize(contClass) {
        return ( contClass == 'container-fluid maincont' ) ? 'container maincont' : 'container-fluid maincont';
    }

    /**
     * Agrega mayúscula a la primera letra de un string
     * @param string
     */
    ucFirst(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }

    /**
     * Devuelve la fecha y hora actual
     */
    getToday(){
      return moment();
    }

    /**
     * Consulta si es un equipo Móvil
     * @returns true / false
     */
    isMobile() {
      // credit to Timothy Huang for this regex test:
      // https://dev.to/timhuang/a-simple-way-to-detect-if-browser-is-on-a-mobile-device-with-javascript-44j3
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      }
      else {
        return false
      }
    }

    /**
     * Valida número de teléfono
     */
    validatePhone(phone) {
      //var re = /^(\+\d{3})?\d{9}$/;
      var re = /^((0|0)9([6-9][1-6])\d{6})$/;
      return re.test(phone.replace(/\s+/g, ''));
    }

  /**
   * Valida Email
   */
    validateEmail(email) {
      var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }

    /**
     * Parseo de Fecha Ej:
     * @param date 20/02/2018 13:16:34
     */
    formatDate(date) {
      return moment(date).format('YYYY-MM-DD HH:mm:ss').toString();
      // var m = moment(date, "YYYY-MM-DD HH:mm:ss");
      // return m.toISOString();
    }

    getYear(date){
      return moment().year(date).toString();
    }
    /**
     * Devuelve la fecha de un String:
     * @param date 20/02/2018 13:16:34
     * @param short Se devuelve fecha corta ( 'DD-MM-YY' )
     * @returns 20/02/2018
     */
    getDay(date, short=false) {
      let fecha = moment(date).format('DD/MM/YYYY').toString();
      if(short){
        fecha = moment(date).format('DD/MM/YY').toString();
      }
      return fecha;
    }
    /**
     * Devuelve el nro de día en base a la fecha pasada
     * @param fecha Devuelve el nro del Día 'D' ( 1 )
     */
    getDayNumber(fecha) {
      fecha = moment(fecha);
      return fecha.day();
    }
    /**
     * Devuelve el nro de día en base a la fecha pasada
     * @param fecha Devuelve el nro del Día 'D' ( 1 )
     */
    getMonthNumber(fecha) {
      fecha = moment(fecha);
      return fecha.getMonthNumber();
    }

    /**
     * De Día, Mes, Año, Hora, Minutos y Segundo devuelve "En x horas"
     * @param time Object, Tiempo a formatear
     * @example timeToHumanDuration({ days: 2, weeks: 2, months: 2, years: 2, hours: 23, minutes: 59, seconds: 59 })
     * @returns Hace 23 Horas
     */
    timeDurationHuman(time){
      let days = (time.days) ? time.days : 0;
      let hours = (time.hours) ? time.hours : 0;
      let minutes = (time.minutes) ? time.minutes : 0;
      let months = (time.months) ? time.months : 0;
      let seconds = (time.seconds) ? time.seconds : 0;
      let weeks = (time.weeks) ? time.weeks : 0;
      let years = (time.years) ? time.years : 0;
      let duracion = this.getDuration(moment.duration({
        days: days,
        hours: hours,
        minutes: minutes,
        months: months,
        seconds: seconds,
        weeks: weeks,
        years: years
      }));
      return duracion;
    }

    /**
    * Devuelve la hora de un String:
    * @param date 20/02/2018 13:16:34
    * @param seconds True o false para segundos
    * @returns 13:16:34
    */
    getHour(date, seconds=true) {
      if(seconds) {
        return moment(date).format('HH:mm:ss').toString();
      } else {
        return moment(date).format('HH:mm').toString();
      }
    }

    /**
    * Devuelve los milisegundos de una hora en String:
    * @param date 20/02/2018 13:16:34
    */
    getMiliSeconds(date) {
      return moment(date).format('X').toString();
    }

    /**
     * Devuelve los milisegundos de una hora, minutos, segundos
     * @param date
     */
    getMiliSecondsByHour(hrs, min, sec) {
      return ((hrs * 60 * 60 + min * 60 + sec) * 1000);
    }

    convertirAMilisegundos(horas, minutos, segundos) {
      // Convertir las horas a milisegundos
      const milisegundosPorHora = 3600000;
      const milisegundosDeHoras = horas * milisegundosPorHora;

      // Convertir los minutos a milisegundos
      const milisegundosPorMinuto = 60000;
      const milisegundosDeMinutos = minutos * milisegundosPorMinuto;

      // Convertir los segundos a milisegundos
      const milisegundosDeSegundos = segundos * 1000;

      // Devolver la suma de las conversiones
      return milisegundosDeHoras + milisegundosDeMinutos + milisegundosDeSegundos;
    }

    /**
    * Devuelve los segundos de una hora en String:
    * @param date 20/02/2018 13:16:34
    */
    getSeconds(date) {
      let result = moment.duration(date, "hours").format("ss");
      result = result.replace(".", "");
      return result;
    }

    /**
       * Día actual desde la hora 00 hasta las 23
       */
    DiaEntero() {
      let nowFdesde = new Date();
      nowFdesde.setDate(nowFdesde.getDate());
      nowFdesde.setHours(0, 0, 0, 0);
      let nowFhasta = new Date();
      nowFhasta.setDate(nowFhasta.getDate());
      nowFhasta.setHours(23, 59, 59);
      let dia = new Date(new Date().getFullYear(),new Date().getMonth() , new Date().getDate());
      let fecha = {
        dia: dia,
        desde: nowFdesde,
        hasta: nowFhasta
      };
      return fecha;
    }

    /**
    * Cuantos días tiene el mes de la fecha enviada
    * @param fecha
    * @example
    * DiasdelMes('2019-10-19 00:00:00');
    */
    DiasdelMes(fecha){
      return moment(fecha, "YYYY-MM-DD HH:mm:ss").daysInMonth();
    }

    /**
    * Trae rango de fecha en los días del mes en base a una fecha
    */
    rangoDiasMes(filter){
      return {
        desde : moment(filter).startOf('day').format('YYYY-MM-DD HH:mm:ss'),
        hasta : moment(filter).endOf('day').format('YYYY-MM-DD HH:mm:ss'),
      }
    }

    /**
    * Cantidad de días entre una fecha desde / hasta
    * @param fdesde diasFecha('19-12-2019 00:00:00')
    * @param fhasta diasFecha('19-12-2019 23:59:59')
    */
    diasFecha(fdesde, fhasta) {
      var a = moment(fdesde);
      var b = moment(fhasta);
      var days = b.diff(a, 'days');
      return days;
    }

    /**
     * Configura una hora
     * @param h Hora
     * @param m Minutos
     * @param s Segundos
     */
    setHoras(h, m, s){
      let tminimo = this.DiaHoraActual();
      tminimo.setDate(tminimo.getDate());
      tminimo.setHours(h, m, s);
      //moment(tminimo).format('HH:mm:ss').toDate();
      return moment(tminimo).toDate();
      //return this.getHour(tminimo);
    }

    /**
     * Verifica si el día enviado está dentro del mes actual
     */
    diaenMesActual(fecha){
        return moment(fecha).isSame(new Date(), 'month');
    }

    /**
    * Trae el día y la hora actual
    */
	  DiaHoraActual() {
      return moment().toDate();
    }

    /**
    * Convierte un string a Date()
    */
	  String2Date(tiempo) {
      return moment(tiempo, "YYYY-MM-DD HH:mm:ss").toDate();
    }

    /**
     * Devuelve el OBS del Outlet Main
     */
    getMainOutletObs() {
      return this.mainOutlet.asObservable();
    }

    /**
     * Agrega un componente en el main outlet
     * @param obj
     * @type string
     * @example setMainOutlet('informe/datos-utiles')
     * En caso de querer vaciar el outlet, pasar false
     */
    setMainOutlet(obj) {
      return this.mainOutlet.next(obj);
    }

    /**
     * Quita horas al tiempo pasado
     */
    restarTiempo(fecha, tipo, restar){
      switch (tipo) {
        case 'horas':
          tipo = 'hours';
          break;
        case 'minutos':
          tipo = 'minutes';
          break;
        default:
          tipo = 'hours';
          break;
      }
      return moment(fecha).subtract(restar, tipo).toDate();
    }

    //https://stackoverflow.com/questions/13262621/how-do-i-use-format-on-a-moment-js-duration
    /**
     * Cambia el formato de duración a fecha / hora
     * @param duration
     * 'P1Y2M3DT4H5M6S';
     */
    getDuration(tiempo){
      let result = this.getSeconds(tiempo);
      return (this.secondsToHour(result)).format;
    }

    //https://stackoverflow.com/questions/13262621/how-do-i-use-format-on-a-moment-js-duration
    /**
     * De una fecha devuelve hora / minuto, sin segundos
     * @param tiempo Date
     */
    getHourMinuteSecond(tiempo){
      return moment(tiempo).format(`HH:mm:ss`);
    }

    validDate(fecha){
      //return moment("05/22/2012", 'MM/DD/YYYY', true).isValid());
      return moment(fecha, 'DD/MM/YYYY HH:mm:ss', true).isValid();
    }

    /**
     * Convierte total de segundos a Hora, Minuto y Segundos
     * @param segundos
     */
    secondsToHour(segundos) {
      let hours:any = Math.floor(segundos / 3600);
      if (hours <= 9) { hours = `0${hours}`; }
      let mins: any = Math.floor(segundos / 60 % 60);
      if (mins <= 9) { mins = `0${mins}`; }
      let secs: any = Math.floor(segundos % 60);
      if (secs <= 9) { secs = `0${secs}`; }
      let timeFormat = {
        hours: hours,
        minutes: mins,
        secs: secs,
        format: `${hours}:${mins}:${secs}`
      };
      return timeFormat;
    }

    /**
     * Tiempo de diferencia entre 2 fecha/hora
     */
    timeDiff(from, to){
      from = (from == 'NOW') ? moment(new Date()) : moment(from);
      to = (to == 'NOW') ? moment(new Date()) : moment(to);
      var duration = moment.duration(to.diff(from));
      var hours = Math.floor(duration.asHours());
      var minutes = Math.floor(duration.asMinutes());
      var seconds = Math.floor(duration.asSeconds());
      var milisegundos = Math.floor(parseFloat(to.diff(from)));
      let timeFormat = {
        from: from.format("DD/MM/YYYY HH:mm:ss"),
        to: to.format("DD/MM/YYYY HH:mm:ss"),
        hours: hours,
        minutes: minutes,
        secs: seconds,
        milisecs: milisegundos,
        duration: this.getDuration(duration)
      };
      return timeFormat;
    }

    /**
     * Metro a Kilometro
     * @param metros mtrTokm(56251)
     */
    mtrTokm(metros) {
      let kilometro = 1000; // Numero de metros en un kilometro :v
      let result = (metros / kilometro).toFixed(2);
      return result;
    }

    showNotif(txt, clase) {
      this.snackBar.open(txt, 'X', {
        duration: 3000,
        horizontalPosition: 'left',
        verticalPosition: 'bottom',
        panelClass: [`${clase}-snackbar`]
      });
    }

    /**
     * formatea numeros para que considere puntos de miles
     */
    formatNumber(nStr) {
      nStr += '';
      var x = nStr.split('.');
      var x1 = x[0];
      var x2 = x.length > 1 ? ',' + x[1] : '';
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) { x1 = x1.replace(rgx, '$1' + '.' + '$2'); }
      return x1 + x2;
    }

    /**
     * Cambia string a title case
     * @param string
     */
    titleCase(string) {
      var sentence = string.trim().toLowerCase().split(" ");
      sentence = sentence.filter(function (el) { return el != null && el != ''; });
      for(var i = 0; i< sentence.length; i++){
        sentence[i] = sentence[i][0].toUpperCase() + sentence[i].slice(1);
      }
      return sentence.join(" ");
    }

    /**
    * Manda Alerta de Notificación Negativa
    * @param txt Texto a enviar, si envia 'error' o 'vacio' muestra un mensaje general
    */
    errorNotif(txt='error') {
      let clase = 'error';
      if (txt == 'error') { txt = 'Ha ocurrido un error, Favor intentarlo más tarde'; }
      if (txt == 'vacio') { txt = 'No cuenta con resultados, Favor verifique los datos ingresados'; }
      this.showNotif(txt, clase);
    }

  /**
   * Manda Alerta de Notificación Positiva
   * @param txt Texto a enviar, si envia ok muestra 'Registro guardado correctamente'
   */
    successNotif(txt='ok') {
      let clase = 'success';
      if (txt == 'ok') { txt = 'Registro guardado correctamente'; }
      this.showNotif(txt, clase);
    }

    /**
     * Manda Alerta de Notificación informativa
     * @param txt Texto a enviar
     */
    infoNotif(txt='Sin Notificación') {
      let clase = 'info';
      this.showNotif(txt, clase);
    }

    /**
     * Realiza llamado a un api separado por lote, esto ayuda para las consultas pesadas con muchos móviles
     * @param filter Parámetros a enviar, Ej: fecha_hora: { between: [filtro.desde, filtro.hasta] },
     * @param total Cantidad de registros totales a recorrer
     * @param endpoint Url a llamar al API
     * @param rows Posición de registros en la respuesta, si devuelve los resultados directos enviar false  Ej: res['rows'], false
     * @example bigApiCall(filter, total, `${environment.baseUrlV2}clientes/control-flota/recorrido`, 'rows');
     */
    async bigApiCall(filter, total, endpoint, rows){
      var cantCalls = (total) ? total : 1; // total de registros
      var limit = (filter.limit) ? filter.limit : 20; // cantidad a llamar por lote
      var cant = (filter.limit) ? filter.limit : 20; // cantidad máx de registros, en caso de ser menor retorna lo que cuente
      var results = []; // almacena los resultados del api
      var offset = 0;
      for (let i = 0; i < cantCalls; i++) {
        offset = i * cant;
        filter.limit = limit;
        filter.offset = offset;
        try {
          const res = await this.http.post(endpoint, filter).toPromise();
          if (rows){
            results = results.concat(res[rows]);
            if (res[rows].length < cant) { break; }
          } else {
            results = results.concat(res);
            if (Object.values(res).length < cant) { break; }
          }

        } catch (error) {
          console.log('Ha ocurrido un error');
        }
      }
      return results;
    }

    /**
     * Llamado para devolver dirección
     * @param lat Latitud del Punto
     * @param long Longitud del Punto
     * @example getAdress(-25.321270,-58.598330 );
     */
    getAdress(lat, long){
      return this.http.get(`${environment.baseUrl}georeferencia/direccion?latitud=${lat}&longitud=${long}`);
    }

    getLocation(lat, long){
      return this.http.get(`${environment.baseUrl}georeferencia/location?latitud=${lat}&longitud=${long}`);
    }
    /**
     * Llamado para devolver puntos cercanos
     * @param lat Latitud del Punto
     * @param long Longitud del Punto
     * @example getPuntosCercanos(-25.321270,-58.598330 );
     */
    getPuntosCercanos(lat, long){
      return this.http.get(`${environment.baseUrl}georeferencia/puntoscercanos?latitud=${lat}&longitud=${long}`);
    }

    async getAdress2(lat, long){
      var results = {};
      try {
        results = await this.http.get(`${environment.baseUrl}georeferencia/direccion?latitud=${lat}&longitud=${long}`).toPromise();
      } catch (error) {
        console.log('Ha ocurrido un error');
        results = [];
      }
      return results;
    }

    /**
     * Ordena alfabeticamente listado de móviles
     * @param a
     * @param b
     * @example moviles.sort(orderMoviles)
     */
    orderMoviles(a, b) {
      const bandA = (a.des_equipo_rastreo) ? a.des_equipo_rastreo.toUpperCase() : a.des_equipo_ratreo.toUpperCase();
      const bandB = (b.des_equipo_rastreo) ? b.des_equipo_rastreo.toUpperCase() : b.des_equipo_ratreo.toUpperCase();
      let comparison = 0;
      if (bandA > bandB) {
        comparison = 1;
      } else if (bandA < bandB) {
        comparison = -1;
      }
      return comparison;
    }
    /**
     * Ordena alfabeticamente listado de geocercas
     * @param a
     * @param b
     * @example moviles.sort(orderMoviles)
     */
    orderPuntos(a, b) {
      const bandA = a.nombre.toUpperCase();
      const bandB = b.nombre.toUpperCase();
      let comparison = 0;
      if (bandA > bandB) {
        comparison = 1;
      } else if (bandA < bandB) {
        comparison = -1;
      }
      return comparison;
    }

    orderGeocercas(a, b) {
      const bandA = a.des_geocerca.toUpperCase();
      const bandB = b.des_geocerca.toUpperCase();
      let comparison = 0;
      if (bandA > bandB) {
        comparison = 1;
      } else if (bandA < bandB) {
        comparison = -1;
      }
      return comparison;
    }
    /**
     * Ordena alfabeticamente listado de geocercas
     * @param a
     * @param b
     * @example moviles.sort(orderMoviles)
     */
    orderRutas(a, b) {
      const bandA = a.des_ruta.toUpperCase();
      const bandB = b.des_ruta.toUpperCase();
      let comparison = 0;
      if (bandA > bandB) {
        comparison = 1;
      } else if (bandA < bandB) {
        comparison = -1;
      }
      return comparison;
    }

     /**
     * Ordena alfabeticamente listado de móviles
     * @param a
     * @param b
     * @example moviles.sort(orderMoviles)
     */
    orderTipoEventos(a, b) {
      const bandA = (a.evento) ? a.evento.toUpperCase() : a.des_equipo_ratreo.toUpperCase();
      const bandB = (b.evento) ? b.evento.toUpperCase() : b.des_equipo_ratreo.toUpperCase();
      let comparison = 0;
      if (bandA > bandB) {
        comparison = 1;
      } else if (bandA < bandB) {
        comparison = -1;
      }
      return comparison;
    }

    getPageSizeOptions(tableCount): number[] {
      let totalOptions = [];
      if (tableCount > 10) { totalOptions.push(10); }
      if (tableCount > 20) { totalOptions.push(20); }
      totalOptions.push(tableCount);
      return totalOptions;
    }

    /**
     * Devuelve la configuración de gráficos FusionChart
     */


    /* getSimpleSpline(){
      const infGraficoConfig = {
        chart: {
          caption: "Variación del Consumo en el Tiempo",
          yaxisname: "Litros",
          anchorradius: "5",
          plottooltext: `Estado del tanque es <b>dataValue</b>`,
          showhovereffect: "1",
          showvalues: "0",
          flatScrollBars: "1",
          numbersuffix: " Ltr",
          theme: "fusion",
          anchorbgcolor: "#72D7B2",
          palettecolors: "#72D7B2"
        },
        data: []
      };
      return infGraficoConfig;
    } */


    // setGraficoDelta
    getScrollBar2D(){
      const data = {
        chart: {
          caption: "Detalle de Variación en Rango",
          //subcaption: "March 2023 ",
          plottooltext: "Volumen $dataValue",
          yaxisname: "Variación del Volumen del Tanque definido en Rango Delta",
          xaxisname: "Fecha-Hora",
          theme: "gammel"
        },
        categories: [
          {
            category: []
          }
        ],
        dataset: [
          {
            data: []
          }
        ]
      };
      return data;
    }

    // setGraficoDeltaLitros
    getscrollstackedcolumn2d(){
      const data = {
        chart: {
          caption: "Estado del Tanque en la linea del tiempo",
          //subcaption: "By Provinces",
          numvisibleplot: "6",
          showvalues: "1",
          decimals: "1",
          stack100percent: "1",
          valuefontcolor: "#000000",
          plottooltext:
            "$label era $dataValue (<b>$percentValue</b>) $seriesName",
          theme: "gammel"
        },
        categories: [
          {
            category: []
          }
        ],
        dataset: [
          {
            seriesname: "Cargado",
            data: []
          },
          {
            seriesname: "Vacio",
            data: []
          }
        ]
      };
      return data;
    }

    getScrollLine2d(){
      const data = {
        chart: {
          caption: "Detalle de la Variación en el tanque",
          subcaption: "(En estado lineal)",
          showvalues: "0",
          numvisibleplot: "12",
          plottooltext:
            "Volúmen <b>$dataValue</b> a las $label",
          theme: "gammel"
        },
        categories: [
          {
            category: [ ]
          }
        ],
        dataset: [
          {
            data: [ ]
          }
        ]
      };
      return data
    }

    getInfGraficoMedidorUFSLitrosConfig(litros, totallitros){
      const ltr = {
        chart: {
          caption: "Indicador Actual del tanque en Litros",
          lowerlimit: "0",
          upperlimit: totallitros,
          lowerlimitdisplay: "Vacio",
          upperlimitdisplay: "LLeno",
          numbersuffix: " litros",
          cylfillcolor: "#1aaf5d",
          plottooltext: `Cantidad Actual: <b>${litros} litros</b>`,
          cylfillhoveralpha: "85",
          theme: "gammel"
        },
        data: [],
        value: litros
      };
      return ltr;
    }

    getInfGraficoMedidorUFSPorcenConfig(porcentaje){

      const porc = {
        chart: {
          //useMessageLog: "1",
          //porcStreamUrl: "&value=70",
         // refreshInterval: "5",
          caption: "Porcentaje Actual en el Tanque",
          lowerlimit: "0",
          upperlimit: "100",
          showvalue: "1",
          numbersuffix: "%",
          theme: "gammel",
          showtooltip: "0",
          //pivotRadius: "10"
        },
        data: [],
        colorrange: {
          color: [
            {
              minvalue: "0",
              maxvalue: "25",
              code: "#F2726F"
            },
            {
              minvalue: "50",
              maxvalue: "65",
              code: "#FFC533"
            },
            {
              minvalue: "65",
              maxvalue: "100",
              code: "#62B58F"
            }
          ]
        },
        dials: {
          dial: [
            {
              value: porcentaje
            }
          ]
        },
        trendpoints: {
          /* point: [
            {
              startValue: 85, // estado anterior del tanque
              displayValue: "Reposte Brusco de Ordeñe",
              endValue: 56, //posicion actual del tanque
              radius: 180,
              innerRadius: 5,
              color: "#cb3234",
              alpha: "40",

              useMarker: "1",
              markerColor: "#cb323",
              markerBorderColor: "#cb323",
              markerRadius: "10",
              markerTooltext: "Reposte Brusco de Ordeñe % Previo era 85 %"
            },
            {
            startValue: 20, // marca previa
            endValue: 56, //marca actual
            radius: 180,
            innerRadius: 5,
            displayValue: "Reposte Brusco de Carga",
            color: "#008000",
            alpha: "40",

            useMarker: "1",
              markerColor: "#008000",
              markerBorderColor: "#008000",
              markerRadius: "10",
              markerTooltext: "Reposte Brusco de Carga % Previo era 20 %"
        }
        ] */
      }
      };
      return porc;
    }
    getInfGraficoConfigUFS_1(){
      let infGraficoConfig = {
        chart: {
          /*
          caption: "Summer Olympics Medal Tally",
          subcaption: "By Countries",
          yaxisname: "Count of Medals",
          plottooltext: "Quarter: $label{br}<b>Region : $seriesName</b>{br}Sales: $dataValue</div>",
          exportFormats: "PNG=Export como imagen|PDF=Exportar como PDF|XLSX=Exportar como Excel",
          */
          //showYAxisValues: "0",
          numvisibleplot: "12",
          labeldisplay: "auto",
          theme: "fusion",
          showValues: "1",
          exportEnabled: "1",
          exportFormats: "PNG=Export como imagen|PDF=Exportar como PDF",
          exportTargetWindow: "_blank",
          exportMode: "server",
          exportFileName: "Informe",
          flatScrollBars: "1",
          plotSpacePercent: 40,
          yAxisMinValue: 0,
          baseFontSize: "11",
        },
        xAxis: {
          outputTimeFormat: {
            // year: " ", //%Y - 2018
            // month: " ", //%B, %Y - September, 2018
            // day: " ", //%B %-d, %Y - November 11, 2018
            hour: "%H", //%b %-d, %Y, %-I %p - Nov 5, 2018, 4 PM
            // minute: " ", //%b %-d, %Y, %-I:%-M %p - Nov 5, 2018, 4:24 PM
            // second: " ", //%b %-d, %Y, %-I:%-M:%-S %p - Nov 5, 2018, 4:25:30 PM
            // millisecond: " " //%b %-d, %Y, %-I:%-M:%-S:%-L %p- Nov 29, 2017, 4:29:12.075 PM
          }
        },
        //Linea Horizontal
        trendlines: [
          {
            line: [
              {
                color: "#1aaf5d", //verde
                dashed: "1",
                displayvalue: "", //valor a mostrar
                endvalue: "",
                startvalue: "", //posición línea
                thickness: "2",
                valueOnRight: 1,
              },{
                color: "#c83f35", //rojo
                dashed: "1",
                displayvalue: "",
                endvalue: "",
                startvalue: "",
                thickness: "2",
                valueOnRight: 1,
              }
            ]
          }
        ],
        categories: [
          {
            category: []
            // {
            //     label: "1994"
            // },
          }
        ],
        dataset: [
          {
            seriesname: 'Litros',
            data: []
            // {
            //     value: 10,
            //     tooltext: `Consumo Total: dddd`,
            //     displayValue: `dd Ltr`
            // }
          },
          {
            seriesname: 'KM Recorridos',
            data: []
            // {
            //     value: 10,
            //     tooltext: `Consumo Total: dddd`,
            //     displayValue: `dd Ltr`
            // }
          },
        ]
      };
      return infGraficoConfig;
    }
    getInfGraficoConfigUFS(){
      let infGraficoConfig = {
        chart: {
          /*
          caption: "Summer Olympics Medal Tally",
          subcaption: "By Countries",
          yaxisname: "Count of Medals",
          plottooltext: "Quarter: $label{br}<b>Region : $seriesName</b>{br}Sales: $dataValue</div>",
          exportFormats: "PNG=Export como imagen|PDF=Exportar como PDF|XLSX=Exportar como Excel",
          */
          //showYAxisValues: "0",
          numvisibleplot: "12",
          labeldisplay: "auto",
          theme: "fusion",
          showValues: "1",
          exportEnabled: "1",
          exportFormats: "PNG=Export como imagen|PDF=Exportar como PDF",
          exportTargetWindow: "_blank",
          exportMode: "server",
          exportFileName: "Informe",
          flatScrollBars: "1",
          plotSpacePercent: 40,
          yAxisMinValue: 0,
          baseFontSize: "11",
        },
        xAxis: {
          outputTimeFormat: {
            // year: " ", //%Y - 2018
            // month: " ", //%B, %Y - September, 2018
            // day: " ", //%B %-d, %Y - November 11, 2018
            hour: "%H", //%b %-d, %Y, %-I %p - Nov 5, 2018, 4 PM
            // minute: " ", //%b %-d, %Y, %-I:%-M %p - Nov 5, 2018, 4:24 PM
            // second: " ", //%b %-d, %Y, %-I:%-M:%-S %p - Nov 5, 2018, 4:25:30 PM
            // millisecond: " " //%b %-d, %Y, %-I:%-M:%-S:%-L %p- Nov 29, 2017, 4:29:12.075 PM
          }
        },
        //Linea Horizontal
        trendlines: [
          {
            line: [
              {
                color: "#1aaf5d", //verde
                dashed: "1",
                displayvalue: "", //valor a mostrar
                endvalue: "",
                startvalue: "", //posición línea
                thickness: "2",
                valueOnRight: 1,
              },{
                color: "#c83f35", //rojo
                dashed: "1",
                displayvalue: "",
                endvalue: "",
                startvalue: "",
                thickness: "2",
                valueOnRight: 1,
              }
            ]
          }
        ],
        categories: [
          {
            category: []
            // {
            //     label: "1994"
            // },
          }
        ],
        dataset: [
          {
            seriesname: 'Litros',
            data: []
            // {
            //     value: 10,
            //     tooltext: `Consumo Total: dddd`,
            //     displayValue: `dd Ltr`
            // }
          },
          {
            seriesname: 'Velocidad',
            data: []
            // {
            //     value: 10,
            //     tooltext: `Consumo Total: dddd`,
            //     displayValue: `dd Ltr`
            // }
          },
        ]
      };
      return infGraficoConfig;
    }

    getInfGraficoFrutika(){
      let infGraficoConfig = {
        chart: {
          /*
          caption: "Summer Olympics Medal Tally",
          subcaption: "By Countries",
          yaxisname: "Count of Medals",
          plottooltext: "Quarter: $label{br}<b>Region : $seriesName</b>{br}Sales: $dataValue</div>",
          exportFormats: "PNG=Export como imagen|PDF=Exportar como PDF|XLSX=Exportar como Excel",
          */
          //showYAxisValues: "0",
          numvisibleplot: "12",
          labeldisplay: "auto",
          theme: "fusion",
          showValues: "1",
          exportEnabled: "1",
          exportFormats: "PNG=Export como imagen|PDF=Exportar como PDF",
          exportTargetWindow: "_blank",
          exportMode: "server",
          exportFileName: "Informe",
          flatScrollBars: "1",
          plotSpacePercent: 40,
          yAxisMinValue: 0,
          baseFontSize: "11",
        },
        xAxis: {
          outputTimeFormat: {
            // year: " ", //%Y - 2018
            // month: " ", //%B, %Y - September, 2018
            // day: " ", //%B %-d, %Y - November 11, 2018
            hour: "%H", //%b %-d, %Y, %-I %p - Nov 5, 2018, 4 PM
            // minute: " ", //%b %-d, %Y, %-I:%-M %p - Nov 5, 2018, 4:24 PM
            // second: " ", //%b %-d, %Y, %-I:%-M:%-S %p - Nov 5, 2018, 4:25:30 PM
            // millisecond: " " //%b %-d, %Y, %-I:%-M:%-S:%-L %p- Nov 29, 2017, 4:29:12.075 PM
          }
        },
        //Linea Horizontal
        trendlines: [
          {
            line: [
              {
                color: "#1aaf5d", //verde
                dashed: "1",
                displayvalue: "", //valor a mostrar
                endvalue: "",
                startvalue: "", //posición línea
                thickness: "2",
                valueOnRight: 1,
              },{
                color: "#c83f35", //rojo
                dashed: "1",
                displayvalue: "",
                endvalue: "",
                startvalue: "",
                thickness: "2",
                valueOnRight: 1,
              }
            ]
          }
        ],
        categories: [
          {
            category: []
            // {
            //     label: "1994"
            // },
          }
        ],
        dataset: [
          {
            seriesname: 'ON/OFF',
            data: []
            // {
            //     value: 10,
            //     tooltext: `Consumo Total: dddd`,
            //     displayValue: `dd Ltr`
            // }
          },
          {
            seriesname: 'Velocidad',
            data: []
            // {
            //     value: 10,
            //     tooltext: `Consumo Total: dddd`,
            //     displayValue: `dd Ltr`
            // }
          },
        ]
      };
      return infGraficoConfig;
    }

    getInfGraficoConfig(){
      let infGraficoConfig = {
        chart: {
          /*
          caption: "Summer Olympics Medal Tally",
          subcaption: "By Countries",
          yaxisname: "Count of Medals",
          plottooltext: "Quarter: $label{br}<b>Region : $seriesName</b>{br}Sales: $dataValue</div>",
          exportFormats: "PNG=Export como imagen|PDF=Exportar como PDF|XLSX=Exportar como Excel",
          */
          //showYAxisValues: "0",
          numvisibleplot: "12",
          labeldisplay: "auto",
          theme: "fusion",
          showValues: "1",
          exportEnabled: "1",
          exportFormats: "PNG=Export como imagen|PDF=Exportar como PDF",
          exportTargetWindow: "_blank",
          exportMode: "server",
          exportFileName: "Informe",
          flatScrollBars: "1",
          plotSpacePercent: 40,
          yAxisMinValue: 0,
          baseFontSize: "11",
        },
        xAxis: {
          outputTimeFormat: {
            // year: " ", //%Y - 2018
            // month: " ", //%B, %Y - September, 2018
            // day: " ", //%B %-d, %Y - November 11, 2018
            hour: "%H", //%b %-d, %Y, %-I %p - Nov 5, 2018, 4 PM
            // minute: " ", //%b %-d, %Y, %-I:%-M %p - Nov 5, 2018, 4:24 PM
            // second: " ", //%b %-d, %Y, %-I:%-M:%-S %p - Nov 5, 2018, 4:25:30 PM
            // millisecond: " " //%b %-d, %Y, %-I:%-M:%-S:%-L %p- Nov 29, 2017, 4:29:12.075 PM
          }
        },
        //Linea Horizontal
        trendlines: [
          {
            line: [
              {
                color: "#1aaf5d", //verde
                dashed: "1",
                displayvalue: "", //valor a mostrar
                endvalue: "",
                startvalue: "", //posición línea
                thickness: "2",
                valueOnRight: 1,
              },{
                color: "#c83f35", //rojo
                dashed: "1",
                displayvalue: "",
                endvalue: "",
                startvalue: "",
                thickness: "2",
                valueOnRight: 1,
              }
            ]
          }
        ],
        categories: [
          {
            category: []
            // {
            //     label: "1994"
            // },
          }
        ],
        dataset: [
          {
            seriesname: null,
            data: []
            // {
            //     value: 10,
            //     tooltext: `Consumo Total: dddd`,
            //     displayValue: `dd Ltr`
            // }
          },
        ]
      };
      return infGraficoConfig;
    }

    /**
     * Exporta un String Html a Descargar
     * @param fileName Nombre del archivo a exportar
     * @param html String Html a convertir
     */
    exportHtml(fileName, html){
      let blob = new Blob([html], { type: 'text/html' });
      fs.saveAs(blob, fileName + '.html');
    }

    /**
     * Exporta archivo a PDF
     * @param exportpdf
     * const pdfData = {
            titulo: 'DISTANCIA RECORRIDA',
            fecha: `2019-08-29 00:00:00`,
            columnwidth: [ 'auto' , '*', 'auto', 'auto', 'auto' ],
            data: data
        };
    * @param fileName
      Nombre del archivo
    * @param openBlank
      True = Abre en pestaña, False = Descarga ( Default )
     */
    exportPdf(exportpdf, fileName, openBlank=false){
        var pdf = {
            pageSize: 'A4',
            pageOrientation: 'landscape',
            pageMargins: [ 20, 60, 20, 60 ],
            header: function(currentPage, pageCount, pageSize) {
                return [
                    {
                        text: 'Global Tracking Paraguay - www.gtp.com.py',
                        alignment: 'right',
                        margin:[20,20,20,0]
                    },
                ]
            },
            footer: function(currentPage, pageCount) {
                return {
                      text: currentPage.toString() + ' de ' + pageCount,
                      alignment: 'right',
                      margin:[20,0,20,0]
                  }
            },
            content: [
            {
                image: environment.logoPdf,
                width: 100,
                margin: [0,-35,0,10]
            },
            { text: exportpdf.titulo, style: 'header' },
            exportpdf.fecha,
            {
              style: 'tableExample',
              margin: [0, 10, 0, 0],
              layout: (exportpdf.borders) ? 'lightHorizontalLines' : 'noBorders',
              table: {
                dontBreakRows: true,
                widths: exportpdf.columnwidth,//[ 'auto' , '*', 'auto', 'auto', 'auto' ],
                body: exportpdf.data
              }
            },
          ],
          styles: {
            header: {
              fontSize: 18,
              bold: true,
              margin: [0, 0, 0, 10]
            },
            subheader: {
              fontSize: 16,
              bold: true,
              margin: [0, 0, 0, 5]
            },
            tableExample: {
              margin: [0, 0, 0, 0]
            },
            tableHeader: {
              bold: true,
              fontSize: 13,
              color: 'black'
            }
          },
          defaultStyle: {
              margin: [10,10,10,10]
          }
        }
        if(openBlank) {
          pdfMake.createPdf(pdf).open();
        } else {
          pdfMake.createPdf(pdf).download(fileName);
        }
    }

    /**
     * Para exportar a archivos Excel
     * @param titulo String
     * @param columns Array
     * @param rows Array
     * @param fileName String
     */
    public exportExcel(titulo, fecha, mycolumns, myrows , fileName) {
        const workbook = new Excel.Workbook();
        let worksheet = workbook.addWorksheet('Informe');

        let logo = workbook.addImage({ base64: environment.logoPdf, extension: 'png' });
        worksheet.addImage(logo, 'A1:C4');
        //worksheet.mergeCells('A2:HJ');

        worksheet.mergeCells('A6:H6');
        worksheet.getCell('A6').value = titulo;
        worksheet.getCell('A6').style = { font: { name: 'Verdana', size: 14, bold: true } };

        worksheet.mergeCells('A8:H8');
        worksheet.getCell('A8').value = fecha;
        worksheet.getCell('A8').style = { font: { name: 'Verdana', size: 12, bold: true } };

        var columns: any = [];
        mycolumns.forEach((e,i) => {
            columns.push(
                {
                    name: e,
                    width: 40,
                    wrapText: true,
                    style: {
                        font: { name: 'Verdana', size: 10 }
                    }
                }
            );
        });

        var rows: any = myrows;

        worksheet.addTable({
            name: 'MyTable',
            ref: 'A10',
            orientation: 'landscape',
            fitToPage: true,
            headerRow: true,
            style: {
                theme: 'TableStyleLight1',
                showRowStripes: true,
            },
            columns: columns,
            rows: rows,
        });

        // worksheet.headerFooter.oddFooter = "Pagina &P de &N";
        workbook.xlsx.writeBuffer().then((data) => {
            let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            fs.saveAs(blob, fileName+'.xlsx');
        });
    }

  /**
   * Para exportar a archivos Excel separado por sheet/tab
   * @param titulo String
   * @param fecha String
   * @param fileName String
   * @param excelBook Array
   */
    public async exportExcelSheets(titulo, fecha, fileName, excelBook) {
        const workbook = new Excel.Workbook();

        for await (const el of excelBook) {
          const mycolumns = el['columns'];
          const rows = el['rows'];

          let worksheet = workbook.addWorksheet(el['sheetname']);

          let logo = workbook.addImage({ base64: environment.logoPdf, extension: 'png' });
          worksheet.addImage(logo, 'A1:C4');
          worksheet.mergeCells('A6:H6');
          worksheet.getCell('A6').value = titulo + ' - ' + el.titulosheet;
          worksheet.getCell('A6').style = { font: { name: 'Verdana', size: 14, bold: true } };
          worksheet.mergeCells('A8:H8');
          worksheet.getCell('A8').value = fecha;
          worksheet.getCell('A8').style = { font: { name: 'Verdana', size: 12, bold: true } };

          worksheet.state = 'visible';

          var columns: any = [];
          mycolumns.forEach((e,i) => {
              columns.push(
                  {
                      name: e,
                      width: 40,
                      wrapText: true,
                      style: {
                          font: { name: 'Verdana', size: 10 }
                      }
                  }
              );
          });

          worksheet.addTable({
              name: 'MyTable',
              ref: 'A10',
              orientation: 'landscape',
              fitToPage: true,
              headerRow: true,
              style: {
                  theme: 'TableStyleLight1',
                  showRowStripes: true,
              },
              columns: columns,
              rows: rows,
          });

        };

        // worksheet.headerFooter.oddFooter = "Pagina &P de &N";
        workbook.xlsx.writeBuffer().then((data) => {
            let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' });
            fs.saveAs(blob, fileName+'.xlsx');
        });

    }

    /**
     * Muestra mensaje de éxito con estilo colorido
     * @param message Mensaje a mostrar
     * @param duration Duración en milisegundos (default: 4000)
     */
    showSuccess(message: string, duration: number = 4000) {
        this.snackBar?.open(message, '✓ CERRAR', {
            duration: duration,
            panelClass: ['success-snackbar'],
            verticalPosition: 'top',
            horizontalPosition: 'center'
        });
    }

    /**
     * Muestra mensaje de error con estilo colorido
     * @param message Mensaje a mostrar
     * @param duration Duración en milisegundos (default: 6000)
     */
    showError(message: string, duration: number = 6000) {
        this.snackBar?.open(message, '✗ CERRAR', {
            duration: duration,
            panelClass: ['error-snackbar'],
            verticalPosition: 'top',
            horizontalPosition: 'center'
        });
    }

    /**
     * Muestra mensaje de información con estilo colorido
     * @param message Mensaje a mostrar
     * @param duration Duración en milisegundos (default: 4000)
     */
    showInfo(message: string, duration: number = 4000) {
        this.snackBar?.open(message, 'ℹ CERRAR', {
            duration: duration,
            panelClass: ['info-snackbar'],
            verticalPosition: 'top',
            horizontalPosition: 'center'
        });
    }

    /**
     * Muestra mensaje de advertencia con estilo colorido
     * @param message Mensaje a mostrar
     * @param duration Duración en milisegundos (default: 5000)
     */
    showWarning(message: string, duration: number = 5000) {
        this.snackBar?.open(message, '⚠ CERRAR', {
            duration: duration,
            panelClass: ['warning-snackbar'],
            verticalPosition: 'top',
            horizontalPosition: 'center'
        });
    }

}
